import { SubscriptionDeliveryCount } from "../SubscriptionDeliveryCount.js";

export const subscriptionDeliveryCountToNumberMap: Record<SubscriptionDeliveryCount, number> = {
	[SubscriptionDeliveryCount.Deliveries3]: 3,
	[SubscriptionDeliveryCount.Deliveries6]: 6,
	[SubscriptionDeliveryCount.Deliveries12]: 12,
};
